import { render, staticRenderFns } from "./SaleData.vue?vue&type=template&id=55a07bd0&scoped=true&"
import script from "./SaleData.vue?vue&type=script&lang=js&"
export * from "./SaleData.vue?vue&type=script&lang=js&"
import style0 from "./SaleData.vue?vue&type=style&index=0&id=55a07bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a07bd0",
  null
  
)

export default component.exports